"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VanillaBot = void 0;
var marked_1 = require("marked");
var ci_component_injector_service_1 = require("@src/services/ci-component-injector.service");
var send_requests_1 = require("./services/send-requests");
var PACKAGE = __importStar(require("../../../package.json"));
var VanillaBot = /** @class */ (function () {
    function VanillaBot() {
        this.conversation = [];
        this.conversations = [];
        this.conversationId = '';
        this.initialMessageTriggered = false;
        this.open = false;
        this.blockInputField = false;
        this.oldConversations = [];
        this.isFirstChat = true;
    }
    VanillaBot.prototype.colorTint = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        var primaryBg = (_c = (_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.primary) !== null && _c !== void 0 ? _c : (_e = (_d = this.settings) === null || _d === void 0 ? void 0 : _d.colorPallete) === null || _e === void 0 ? void 0 : _e.primaryBackground;
        var background = (_h = (_g = (_f = this.settings) === null || _f === void 0 ? void 0 : _f.colors) === null || _g === void 0 ? void 0 : _g.background) !== null && _h !== void 0 ? _h : (_k = (_j = this.settings) === null || _j === void 0 ? void 0 : _j.colorPallete) === null || _k === void 0 ? void 0 : _k.background;
        var secondary = (_o = (_m = (_l = this.settings) === null || _l === void 0 ? void 0 : _l.colors) === null || _m === void 0 ? void 0 : _m.secondary) !== null && _o !== void 0 ? _o : (_q = (_p = this.settings) === null || _p === void 0 ? void 0 : _p.colorPallete) === null || _q === void 0 ? void 0 : _q.answerBubble['background'];
        var color = typeof primaryBg === 'string'
            ? primaryBg.replace(/^#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/, '#$1$1$2$2$3$3')
            : '#333333';
        if (((_r = this.settings) === null || _r === void 0 ? void 0 : _r.theme) === 'dark') {
            this.ciLottiePlayer.replaceColor = { '#ffffff': 'transparent' };
            this.ciLottiePlayer.colorMapping = ['#ffffff', '#ffffff', '#ffffff', color, color, color, '#ffffff', '#ffffff'];
        }
        else {
            this.ciLottiePlayer.colorMapping = [color, color, color, '#ffffff', '#ffffff', '#ffffff', color, color];
        }
        if (typeof primaryBg === 'string') {
            document.documentElement.style.setProperty('--light-action-primary-default', primaryBg);
            document.documentElement.style.setProperty('--dark-action-primary-default', primaryBg);
        }
        if (typeof background === 'string') {
            document.documentElement.style.setProperty('var(--dark-background-default)', background);
            document.documentElement.style.setProperty('var(--light-background-default)', background);
        }
        if (typeof secondary === 'string') {
            document.documentElement.style.setProperty('--color-customer-color-light-200', secondary);
        }
    };
    VanillaBot.prototype.loadModule = function (settings) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, chatWrapper;
            var _this = this;
            var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
            return __generator(this, function (_1) {
                switch (_1.label) {
                    case 0:
                        localStorage.removeItem('conversationIds');
                        localStorage.removeItem('lastConversationContact');
                        localStorage.removeItem('conversationId');
                        console.log('fitbot settings raw', JSON.parse(JSON.stringify(settings)));
                        this.tenant = (settings === null || settings === void 0 ? void 0 : settings.tenant) || (settings === null || settings === void 0 ? void 0 : settings.tenantKey);
                        _1.label = 1;
                    case 1:
                        _1.trys.push([1, 6, , 7]);
                        if (!settings.debug) return [3 /*break*/, 3];
                        _a = [{ tenant: this.tenant }];
                        return [4 /*yield*/, (0, send_requests_1._GetConfig)(this.tenant)];
                    case 2:
                        settings = __assign.apply(void 0, [__assign.apply(void 0, _a.concat([((_d = (_1.sent())) !== null && _d !== void 0 ? _d : {})])), settings]);
                        return [3 /*break*/, 5];
                    case 3:
                        _b = [__assign({ tenant: this.tenant }, settings)];
                        return [4 /*yield*/, (0, send_requests_1._GetConfig)(this.tenant)];
                    case 4:
                        settings = __assign.apply(void 0, _b.concat([((_e = (_1.sent())) !== null && _e !== void 0 ? _e : {})]));
                        _1.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        _c = _1.sent();
                        return [3 /*break*/, 7];
                    case 7:
                        this.settings = settings;
                        (0, ci_component_injector_service_1._InjectStencilWebComponents)();
                        chatWrapper = document.createElement('div');
                        chatWrapper.style.cssText = 'position:absolute;z-index:10000';
                        chatWrapper.classList.add('fittec-fitbot-wrapper');
                        // Create and cast to our custom element interface
                        this.ciChatWindow = document.createElement('ci-chat-window');
                        this.ciLottiePlayer = document.createElement('ci-lottie-player');
                        this.ciLottiePlayer.url = 'https://files.fittec.io/files/frontend/' + PACKAGE.version + '/dev/fitKI/assets/fitbot.json';
                        this.ciLottiePlayer.size = '60px';
                        // Set initial properties via attributes and direct assignment
                        this.ciChatWindow.customIcon = true;
                        this.ciChatWindow['dangerouslyRenderElements'] = true;
                        this.ciChatWindow.setAttribute('toggle-button', 'true');
                        this.ciChatWindow.setAttribute('toggle-button-title', 'fitbot - die beste ki um dich zu unterstützen');
                        this.ciChatWindow.setAttribute('open', String(this.open));
                        this.ciChatWindow.setAttribute('name', this.settings.name);
                        this.ciChatWindow.setAttribute('sender-typing', 'true');
                        this.ciChatWindow.setAttribute('theme', ((_f = this.settings) === null || _f === void 0 ? void 0 : _f.theme) || 'light');
                        if ((_g = this.settings) === null || _g === void 0 ? void 0 : _g.showNumberOfUnreadChats) {
                            this.ciChatWindow.setAttribute('number-of-unread-messages', String((_j = (_h = this.settings) === null || _h === void 0 ? void 0 : _h.showNumberOfUnreadChats) !== null && _j !== void 0 ? _j : 'false'));
                        }
                        if ((_l = (_k = this.settings) === null || _k === void 0 ? void 0 : _k.toggleButtonHelpMessage) === null || _l === void 0 ? void 0 : _l.length) {
                            this.ciChatWindow.setAttribute('toggle-button-help-message', this.settings.toggleButtonHelpMessage);
                            if ((_m = this.settings) === null || _m === void 0 ? void 0 : _m.toggleButtonHelpAvatar) {
                                this.ciChatWindow.setAttribute('toggle-button-help-message-avatar', String(this.settings.toggleButtonHelpAvatar));
                            }
                        }
                        if (((_p = (_o = this.settings) === null || _o === void 0 ? void 0 : _o.whatsapp) === null || _p === void 0 ? void 0 : _p.showQrCode) && ((_s = (_r = (_q = this.settings) === null || _q === void 0 ? void 0 : _q.whatsapp) === null || _r === void 0 ? void 0 : _r.phoneNumber) === null || _s === void 0 ? void 0 : _s.length)) {
                            this.ciChatWindow.setAttribute('whatsapp-number', 'https://wa.me/' + this.settings.whatsapp.phoneNumber);
                            if (((_v = (_u = (_t = this.settings) === null || _t === void 0 ? void 0 : _t.whatsapp) === null || _u === void 0 ? void 0 : _u.qrCodeColor) === null || _v === void 0 ? void 0 : _v.length) || ((_y = (_x = (_w = this.settings) === null || _w === void 0 ? void 0 : _w.colors) === null || _x === void 0 ? void 0 : _x.primary) === null || _y === void 0 ? void 0 : _y.length)) {
                                this.ciChatWindow.setAttribute('whatsapp-color', ((_0 = (_z = this.settings) === null || _z === void 0 ? void 0 : _z.whatsapp) === null || _0 === void 0 ? void 0 : _0.qrCodeColor) || this.settings.colors.primary);
                            }
                        }
                        this.ciChatWindow.defaultUserAvatar = {
                            shortcode: 'YOU',
                        };
                        if (this.settings.name || this.settings.image) {
                            this.ciChatWindow.defaultSenderAvatar = {
                                image: this.settings.image || "https://files.fittec.io/files/frontend/2.1.0/prod/fitKI/assets/bot-image.png",
                                username: this.settings.name,
                            };
                        }
                        // Listen for changes from the chat window
                        this.ciChatWindow.addEventListener('change', function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var detail, index, textForAI, data, selectedConversation, messageObj;
                            var _a, _b, _c, _d, _e;
                            return __generator(this, function (_f) {
                                switch (_f.label) {
                                    case 0:
                                        detail = event.detail;
                                        console.log(detail);
                                        if (detail.statusCode === 12 && ((_b = (_a = detail === null || detail === void 0 ? void 0 : detail.sourceElement) === null || _a === void 0 ? void 0 : _a.getAttribute('data-retry')) === null || _b === void 0 ? void 0 : _b.length)) {
                                            this.retryLastMessage();
                                        }
                                        if ((detail === null || detail === void 0 ? void 0 : detail.statusCode) === 12 && ((_d = (_c = detail === null || detail === void 0 ? void 0 : detail.sourceElement) === null || _c === void 0 ? void 0 : _c.getAttribute('text-for-ai')) === null || _d === void 0 ? void 0 : _d.length)) {
                                            index = this.conversation.findIndex(function (a) { var _a; return (_a = a === null || a === void 0 ? void 0 : a.components) === null || _a === void 0 ? void 0 : _a.length; });
                                            this.conversation.splice(index, 1);
                                            textForAI = (_e = detail === null || detail === void 0 ? void 0 : detail.sourceElement) === null || _e === void 0 ? void 0 : _e.getAttribute('text-for-ai');
                                            this.sendMessageTofitbot({
                                                tenant: this.tenant,
                                                operation: 'simple',
                                                textInput: textForAI,
                                            });
                                        }
                                        if ((detail === null || detail === void 0 ? void 0 : detail.statusCode) !== 11)
                                            return [2 /*return*/];
                                        data = detail.data;
                                        if (data.reactionTriggered === 'fittec-thumb-down') {
                                            (0, send_requests_1._SendDislike)(this.tenant, this.conversationId);
                                        }
                                        if (!(data.menu === 'chat-history')) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.loadOldChats()];
                                    case 1:
                                        _f.sent();
                                        _f.label = 2;
                                    case 2:
                                        if (!(data.menu === 'chat-history-clicked')) return [3 /*break*/, 4];
                                        selectedConversation = this.oldConversations.find(function (a) { return a.uuid === data.uuid; });
                                        if (!selectedConversation) return [3 /*break*/, 4];
                                        return [4 /*yield*/, this.loadOldConversation({
                                                conversationId: selectedConversation.uuid,
                                                messageHistory: selectedConversation.messageHistory,
                                            })];
                                    case 3:
                                        _f.sent();
                                        _f.label = 4;
                                    case 4:
                                        if (!(data.menu === 'chat-history-new-chat')) return [3 /*break*/, 6];
                                        return [4 /*yield*/, this.newChat()];
                                    case 5:
                                        _f.sent();
                                        _f.label = 6;
                                    case 6:
                                        if (!((data === null || data === void 0 ? void 0 : data.open) !== undefined)) return [3 /*break*/, 8];
                                        this.open = data.open;
                                        return [4 /*yield*/, this.getConversations()];
                                    case 7:
                                        _f.sent();
                                        console.log('Load Conversation ID ', this.conversationId, this.conversations);
                                        console.log('fitbot settings', JSON.parse(JSON.stringify(settings)));
                                        this.updateChatWindow();
                                        if (!this.initialMessageTriggered && this.open) {
                                            this.triggerInitialMessage();
                                        }
                                        _f.label = 8;
                                    case 8:
                                        if (data === null || data === void 0 ? void 0 : data.message) {
                                            messageObj = data.message;
                                            this.sendMessageTofitbot({
                                                tenant: this.tenant,
                                                operation: 'simple',
                                                textInput: messageObj.message,
                                            });
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        // Optionally open after a delay
                        // if (this.settings.openAfterSeconds && this.settings.openAfterSeconds > 0) {
                        //   setTimeout(() => {
                        //     this.open = true;
                        //     this.updateChatWindow();
                        //     if (!this.initialMessageTriggered && this.open) {
                        //       this.triggerInitialMessage();
                        //     }
                        //   }, this.settings.openAfterSeconds * 1000);
                        // }
                        this.colorTint();
                        chatWrapper.appendChild(this.ciChatWindow);
                        document.body.appendChild(chatWrapper);
                        this.ciChatWindow.appendChild(this.ciLottiePlayer);
                        return [2 /*return*/];
                }
            });
        });
    };
    VanillaBot.prototype.updateChatWindow = function () {
        this.ciChatWindow.setAttribute('open', String(this.open));
        this.ciChatWindow.messages = this.conversation;
    };
    VanillaBot.prototype.triggerInitialMessage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var components;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(this.open && !this.initialMessageTriggered)) return [3 /*break*/, 2];
                        this.initialMessageTriggered = true;
                        return [4 /*yield*/, this.sendMessageTofitbot({
                                tenant: this.tenant,
                                operation: 'simple',
                                textInput: '',
                            })];
                    case 1:
                        _c.sent();
                        if ((_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.initialButtons) === null || _b === void 0 ? void 0 : _b.length) {
                            components = this.settings.initialButtons
                                .map(function (a) {
                                return [
                                    {
                                        component: 'ci-button',
                                        attributes: {
                                            class: 'm-4',
                                            option: 'primary',
                                            'text-for-ai': a.sendText,
                                        },
                                        innerHTML: a.label,
                                    },
                                ];
                            })
                                .flat();
                            this.conversation.push({
                                date: new Date(),
                                message: 'Beliebte anfragen',
                                tranceiver: 'user',
                                components: components,
                            });
                        }
                        this.updateChatWindow();
                        _c.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    VanillaBot.prototype.sendMessageTofitbot = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if ((_a = data === null || data === void 0 ? void 0 : data.textInput) === null || _a === void 0 ? void 0 : _a.length) {
                            this.conversation.push({
                                date: new Date(),
                                message: data.textInput,
                                tranceiver: 'user',
                            });
                        }
                        this.updateChatWindow();
                        return [4 /*yield*/, this.requestAIResponse(data)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    VanillaBot.prototype.retryLastMessage = function () {
        console.log('RETRY LAST MESSAGE');
    };
    VanillaBot.prototype.requestAIResponse = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, parsedAnswer, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.ciChatWindow.setAttribute('sender-typing', 'true');
                        this.ciChatWindow.senderTyping = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 7]);
                        return [4 /*yield*/, (0, send_requests_1._PerformRequest)(this.tenant, this.conversationId, data, this.isFirstChat)];
                    case 2:
                        response = _b.sent();
                        this.ciChatWindow.setAttribute('sender-typing', 'false');
                        this.ciChatWindow.senderTyping = false;
                        if ((response === null || response === void 0 ? void 0 : response.conversationId) && !((_a = this.conversationId) === null || _a === void 0 ? void 0 : _a.length)) {
                            this.conversationId = response.conversationId;
                        }
                        if (this.conversation.length > 2) {
                            //more than just welcome message.
                            this.addConversationId(this.conversationId);
                        }
                        return [4 /*yield*/, (0, marked_1.marked)(response.answer)];
                    case 3:
                        parsedAnswer = _b.sent();
                        this.conversation.push({
                            date: new Date(),
                            message: parsedAnswer,
                            tranceiver: 'sender',
                        });
                        return [3 /*break*/, 7];
                    case 4:
                        error_1 = _b.sent();
                        console.error('KI ERROR', error_1);
                        if (error_1 === 'retryButton') {
                            this.conversation.push({
                                message: 'Oh nein es gab einen Fehler. Beim drücken auf den knopf versuchen wir es nochmal.',
                                date: new Date(),
                                tranceiver: 'sender',
                                components: [
                                    {
                                        component: 'ci-button',
                                        attributes: {
                                            'data-retry': 'true',
                                        },
                                        innerHTML: 'Neuer versuch',
                                    },
                                ],
                            });
                        }
                        if (!(error_1 === 'requestGPS')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.geoLocationRequested(__assign({}, data))];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [3 /*break*/, 7];
                    case 7:
                        this.updateChatWindow();
                        this.ciChatWindow.setAttribute('sender-typing', 'false');
                        this.ciChatWindow.senderTyping = false;
                        this.isFirstChat = false;
                        this.blockInputField = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    VanillaBot.prototype.loadOldChats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promises, _i, _a, conversation, conversations, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        promises = [];
                        for (_i = 0, _a = this.conversations; _i < _a.length; _i++) {
                            conversation = _a[_i];
                            promises.push((0, send_requests_1._GetConversation)(this.tenant, conversation.id));
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        conversations = _c.sent();
                        this.oldConversations = conversations.map(function (a) { return ({
                            date: a.messageHistory[0].timestamp,
                            text: a.messageHistory[a.messageHistory.length - 1].content,
                            uuid: a.conversationId,
                            messageHistory: a.messageHistory,
                        }); });
                        this.ciChatWindow['chatHistory'] = this.oldConversations;
                        return [3 /*break*/, 3];
                    case 2:
                        _b = _c.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VanillaBot.prototype.newChat = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isFirstChat = true;
                        this.conversationId = undefined;
                        this.initialMessageTriggered = false;
                        this.conversation = [];
                        this.updateChatWindow();
                        return [4 /*yield*/, this.triggerInitialMessage()];
                    case 1:
                        _a.sent();
                        this.updateChatWindow();
                        return [2 /*return*/];
                }
            });
        });
    };
    VanillaBot.prototype.loadOldConversation = function (conversation) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, message, _b, _c, _d;
            var _e;
            var _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        console.log('GET CONVO', conversation);
                        if (!((_f = conversation === null || conversation === void 0 ? void 0 : conversation.messageHistory) === null || _f === void 0 ? void 0 : _f.length))
                            return [2 /*return*/];
                        this.isFirstChat = false;
                        this.initialMessageTriggered = true;
                        _i = 0, _a = conversation.messageHistory;
                        _g.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 6];
                        message = _a[_i];
                        _c = (_b = this.conversation).push;
                        _e = {
                            date: new Date(message.timestamp)
                        };
                        if (!(message.role === 'assistant')) return [3 /*break*/, 3];
                        return [4 /*yield*/, (0, marked_1.marked)(message.content)];
                    case 2:
                        _d = _g.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _d = message.content;
                        _g.label = 4;
                    case 4:
                        _c.apply(_b, [(_e.message = _d,
                                _e.tranceiver = message.role === 'assistant' ? 'sender' : 'user',
                                _e)]);
                        _g.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        this.ciChatWindow.setAttribute('sender-typing', 'false');
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * We get conversation ids from localstorage if last conversation is > 24 hours ago we start new conversation
     * else we load the last conversation where they stopped
     */
    VanillaBot.prototype.getConversations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var raw, jsonRaw, latestConversation, last, getConvo, _a, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 6, , 7]);
                        raw = localStorage.getItem('fitagentConversations');
                        jsonRaw = raw ? JSON.parse(raw) : [];
                        this.conversations = jsonRaw.map(function (a) { return (__assign(__assign({}, a), { date: new Date(a.date) })); });
                        if (!((_c = this.conversations) === null || _c === void 0 ? void 0 : _c.length))
                            return [2 /*return*/];
                        this.ciChatWindow['chatHistoryButton'] = true;
                        latestConversation = this.conversations[this.conversations.length - 1];
                        if (!latestConversation) return [3 /*break*/, 5];
                        last = new Date(latestConversation.date).getTime();
                        if (!(Date.now() - last < 24 * 60 * 60 * 1000 && this.conversations.length)) return [3 /*break*/, 5];
                        this.conversationId = latestConversation.id;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, (0, send_requests_1._GetConversation)(this.tenant, this.conversationId)];
                    case 2:
                        getConvo = _d.sent();
                        return [4 /*yield*/, this.loadOldConversation(getConvo)];
                    case 3:
                        _d.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _d.sent();
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        _b = _d.sent();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    VanillaBot.prototype.updateConversations = function () {
        localStorage.setItem('fitagentConversations', JSON.stringify(this.conversations));
    };
    VanillaBot.prototype.addConversationId = function (conversationId) {
        if (this.conversations.some(function (a) { return a.id === conversationId; }))
            return;
        this.conversations.push({ id: conversationId, date: new Date() });
        console.log('Set conversation ID', conversationId, this.conversations);
        this.updateConversations();
    };
    VanillaBot.prototype.geoLocationRequested = function (data) {
        var _this = this;
        console.error('REQUEST GPS');
        if (!navigator.geolocation) {
            console.log('Geolocation is not supported by this browser.');
            return this.requestAIResponse(__assign(__assign({}, data), { location: 'permission denied' }));
        }
        var requestPosition = function () {
            navigator.geolocation.getCurrentPosition(function (position) {
                _this.requestAIResponse(__assign(__assign({}, data), { location: {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    } }));
            }, function () {
                _this.requestAIResponse(__assign(__assign({}, data), { location: 'permission denied' }));
            });
        };
        if (navigator.permissions) {
            navigator.permissions.query({ name: 'geolocation' }).then(function (status) {
                if (status.state === 'granted') {
                    requestPosition();
                }
                else {
                    _this.conversation.push({
                        date: new Date(),
                        tranceiver: 'sender',
                        message: 'Bitte teile den Standort hier im Browser um die Frage bestmöglich zu beantworten',
                        components: [
                            {
                                component: 'ci-icon',
                                attributes: {
                                    icon: 'location',
                                    class: 'm-8',
                                    size: '20px',
                                    style: { display: 'block' },
                                },
                                innerHTML: '',
                            },
                        ],
                    });
                    requestPosition();
                }
            });
        }
        else {
            // Fallback if Permissions API is unavailable
            this.conversation.push({
                date: new Date(),
                tranceiver: 'sender',
                message: 'Bitte teile den Standort hier im Browser um die Frage bestmöglich zu beantworten',
                components: [
                    {
                        component: 'ci-icon',
                        attributes: {
                            icon: 'location',
                            class: 'm-8',
                            size: '20px',
                            style: { display: 'block' },
                        },
                        innerHTML: '',
                    },
                ],
            });
            requestPosition();
        }
    };
    return VanillaBot;
}());
exports.VanillaBot = VanillaBot;
